// Leitura do retorno de `/lancamentos/add-saldo-conexao-caixa`. Fica fora dos
// componentes porque duas partes precisam da mesma resposta: o painel, que
// desenha o banner de pendencias, e a casca, que decide se ainda cabe o toast
// verde de sucesso.

const lista = (retorno, campo) =>
  Array.isArray(retorno && retorno[campo]) ? retorno[campo] : [];

export const naoMapeados = (retorno) => lista(retorno, "nao_mapeados");

export const divergenciasCategorias = (retorno) => lista(retorno, "divergencias_categorias");

export const errosGravacao = (retorno) => lista(retorno, "erros_gravacao");

export const mapeamento = (retorno) => (retorno && retorno.mapeamento) || {};

export const temPendencias = (retorno) => {
  if (!retorno || retorno.success !== true) return false;

  const categoriaDivergente = divergenciasCategorias(retorno).some(
    (item) => item.consistente === false
  );

  return (
    retorno.requer_conferencia === true ||
    naoMapeados(retorno).length > 0 ||
    errosGravacao(retorno).length > 0 ||
    itensNegativos(retorno).length > 0 ||
    categoriaDivergente
  );
};

export const formatarMoeda = (valor) =>
  Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const itensNegativos = (retorno) => lista(retorno, "itens_negativos");

const horaDe = (dataHora) => {
  const encontrado = /(\d{2}):(\d{2})/.exec(String(dataHora || ""));
  return encontrado ? `${encontrado[1]}:${encontrado[2]}` : "";
};

const sessoesSemFoto = (base) =>
  base && Array.isArray(base.sessoes_sem_foto) ? base.sessoes_sem_foto : [];

// Faixa do painel: o que esta sessão descontou do acumulado do dia. Vazio no
// turno único, que importa o relatório inteiro como sempre.
export const textoBase = (base) => {
  if (!base || base.tipo === "nenhuma") return "";

  const partes = [];
  if (base.sessao_foto) {
    const hora = horaDe(base.foto_importada_em);
    partes.push(`o relatório importado pela Sessão ${base.sessao_foto}${hora ? ` às ${hora}` : ""}`);
  }
  if (sessoesSemFoto(base).length) {
    partes.push(`os lançamentos da Sessão ${sessoesSemFoto(base).join(", ")}`);
  }

  if (!partes.length) return "";

  return `Sessão ${base.sessao} do terminal ${base.terminal} — desconta ${partes.join(" e ")}`;
};

export const textoLiberacao = (base) =>
  sessoesSemFoto(base).length
    ? `A Sessão ${sessoesSemFoto(base).join(", ")} do terminal ${base.terminal} não foi importada pelo Conexão Parceiro. Peça ao gerente para liberar.`
    : "";

export const textoConfirmacaoLiberacao = (base) => {
  const lancamentos = (base && base.lancamentos) || { valor: 0, itens: 0 };
  const itens = lancamentos.itens === 1 ? "1 item" : `${lancamentos.itens} itens`;

  return `Serão descontados os lançamentos da Sessão ${sessoesSemFoto(base).join(", ")}: ` +
    `${formatarMoeda(lancamentos.valor)} em ${itens}. Confirma a importação?`;
};

const MOTIVOS = {
  produto_nao_encontrado: "Produto ou nomenclatura não cadastrado/ativo",
  categoria_nao_encontrada: "Categoria não reconhecida"
};

export const formatarMotivo = (motivo) => MOTIVOS[motivo] || motivo || "-";
